var _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10,
    r: 9,
    fill: "url(#paint0_linear_1606_8331)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1606_8331",
    x1: 10.5,
    y1: 1,
    x2: 10.5,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B5B5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradient);
export default __webpack_public_path__ + "static/media/gradient.2a00f73f4a2c4093dca3b4d262def1f7.svg";
export { ForwardRef as ReactComponent };